import { ViewTracker, formatAnalyticsValue } from '@blueshift-ui/telemetry';

import OopsPage from '../pages/oops';
import React from 'react';
import SecondaryLayout from '../layouts/secondary';
import logError from '../utilities/logging/log-error';

//

class AppErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return {
      error,
      hasError: true,
    };
  }

  //

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    logError(error);
  }

  render() {
    if (this.state.hasError) {
      // Note: a redirect to the oops page won't work in an error boundary, so we render it directly
      return (
        <SecondaryLayout>
          <ViewTracker
            analytics={{
              action: 'oops',
              category: 'learning-lab',
              label: formatAnalyticsValue(this.state.error?.message, 'label'),
            }}
          >
            <OopsPage />
          </ViewTracker>
        </SecondaryLayout>
      );
    }

    return this.props.children;
  }
}

// Exports
// -------

export default AppErrorBoundary;
